import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import VisionMissionValues from "../components/VisionMissionValues";
import Divisions from "../components/Divisions";
import Clients from "../components/Clients";
import PWTPartnership from "../components/PWTPartnership";
import WorldMap from "../components/WorldMap";
import Leadership from "../components/Leadership";
import Referrals from "../components/Referrals";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white">
      <Header />
      <main>
        <Hero />
        <VisionMissionValues />
        <Divisions />
        <Clients />
        <PWTPartnership />
        <WorldMap />
        <Leadership />
        <Referrals />
      </main>
      <Footer />
    </div>
  );
}
